export const setPromoCodeInputDisplay = (display) => ({
    type: 'SET_PROMO_CODE_INPUT_DISPLAY',
    payload: display,
});
